import "./Callpage.css";
import React, { Fragment, useState, useEffect, useMemo } from "react";
import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import Home from "./home";
import { useTranslation } from "react-i18next";
const BackendURL = window.BackendURLCmk;
var oopen = false;
var callTimers = {};
var ableButton;
var opacityButton;
var transfertSession = {};

var iconWindow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 m-auto text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    {" "}
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
    ></path>{" "}
  </svg>
);

var Stopwatch = function (elem, options) {
  // private functions
  function createTimer() {
    return document.createElement("span");
  }

  var timer = createTimer(),
    offset,
    clock,
    interval;

  // default options
  options = options || {};
  options.delay = options.delay || 1000;
  options.startTime = options.startTime;

  // append elements
  elem.appendChild(timer);

  function start() {
    if (!interval) {
      offset = options.startTime;
      interval = setInterval(update, options.delay);
    }
  }

  function stop() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  function reset() {
    clock = 0;
    render();
  }

  function update() {
    clock += delta();
    render();
  }

  function render() {
    timer.innerHTML = moment(clock).format("mm:ss");
  }

  function delta() {
    var now = Date.now(),
      d = now - offset;

    offset = now;
    return d;
  }

  // initialize
  reset();

  // public API
  this.start = start; //function() { start; }
  this.stop = stop; //function() { stop; }
};

function CallPage({
  holdCall,
  muteCall,
  activecall,
  holdSession,
  hungUp,
  upBtn,
  acceptappel,
  openmodel,
  session,
  changeSession,
  ConferenceCall,
  upBtnVideo,
  transfertCall,
  newcallClick,
  modalSendCall,
  muteSession,
  tab,
  navbar,
  clickBack,
  backHomeVariable,
  openBackHome,
  closeBackHome,
  openBackHomeConference,
  sendDTMF,
  callTransfert,
  transfertCallAcc,
  activeTransfert,
}) {
  let [isOpen, setIsOpen] = useState(false);
  let [isOpenTransfert, setIsOpenTransfert] = useState(false);
  let [isOpenSendCall, setIsOpenSendCall] = useState(false);
  const [number, setNumber] = useState("");
  const [numberSendCall, setNumberSendCall] = useState("");
  const [heightWindow, setHeightWindow] = useState("block");
  const [showResults, setShowResults] = useState(true);
  const [numberDtmf, setNumberDtmf] = useState("");
  const [isConfirmOpened, setIsConfirmOpened] = useState(false);
  const [callActive, setCallActive] = useState(undefined);
  const [accountCall, setAccountCall] = useState({
    name: "",
    number: "",
  });
  const [imageCall, setImageCall] = useState(null);
  const [holdCallColor, setHoldCallColor] = useState({
    color: "",
    colorHold: "",
    colorMember: "",
    colorHoldMember: "",
  });

  const [muteCallColor, setMuteColor] = useState({
    colorIconMute: "",
    colorMute: "",
  });
  const { t } = useTranslation("common");
  // const [backHome, setBackHome] = useState(backHomeVariable);
  useEffect(() => {
    let activeCallState;
    if (session.length > 1) {
      activeCallState = activecall === "" ? session[0] : activecall;
      setCallActive(activecall === "" ? session[0] : activecall);
    } else if (session.length === 0) {
      activeCallState = undefined;
    } else {
      activeCallState = session[0];

      setCallActive(session[0]);
    }

    if (activeCallState?.statusAppel !== "ringing") {
      const tEle = document.getElementById("watch");
      if (tEle) {
        tEle.innerHTML = "";
        callTimers[activeCallState] = new Stopwatch(tEle, {
          startTime: activeCallState?.date,
        });
        callTimers[activeCallState].start();
      }
    } else callTimers[activeCallState]?.stop();

    setIsConfirmOpened(
      activeTransfert !== undefined && !(activeTransfert?.statusAppel === "end")
    );

    setHoldCallColor((prev) => ({
      ...prev,
      color:
        activeCallState?.statusAppel === "holding" || holdCall
          ? "text-gray-900"
          : "text-gray-50",
      colorHold:
        activeCallState?.statusAppel === "holding" || holdCall
          ? "white"
          : "rgb(255 255 255 / 25%)",
    }));

    if (activeCallState?.conf !== "null") {
      setHoldCallColor((prev) => ({
        ...prev,
        colorMember:
          activeCallState?.statusAppel === "holding" || holdCall
            ? "text-gray-900"
            : "text-gray-50",
        colorHoldMember:
          activeCallState?.statusAppel === "holding" || holdCall
            ? "white"
            : "rgb(255 255 255 / 25%)",
      }));
    }
    setMuteColor({
      colorIconMute:
        activeCallState?.ismute === "yes" || muteCall
          ? "text-gray-900"
          : "text-gray-50",
      colorMute:
        activeCallState?.ismute === "yes" || muteCall
          ? "white"
          : "rgb(255 255 255 / 25%)",
    });

    if (
      ![
        null,
        undefined,
        "",
        "https://172.16.40.239:4444/comunik_fichiers/client/upload/avatar/",
      ].includes(
        tab?.find(
          (element) =>
            element.poste === activeCallState?.remoteIdentity?.uri?.user
        )?.photo_poste_interne
      )
    ) {
      setImageCall(
        tab?.find(
          (element) =>
            element.poste === activeCallState?.remoteIdentity?.uri?.user
        )?.lien_photo_poste_interne
      );
    } else {
      setImageCall(null);
    }

    if (
      tab?.find(
        (element) =>
          element.poste === activeCallState?.remoteIdentity?.uri?.user
      ) !== undefined
    ) {
      setAccountCall({
        name: tab?.find(
          (element) =>
            element.poste === activeCallState?.remoteIdentity?.uri?.user
        )?.nom,
        number: tab?.find(
          (element) =>
            element.poste === activeCallState?.remoteIdentity?.uri?.user
        )?.poste,
      });
    } else {
      setAccountCall({
        name: activeCallState?.remoteIdentity?.displayName,
        number: activeCallState?.remoteIdentity?.uri?.user,
      });
    }
  }, [activecall, holdCall, tab, session, activeTransfert, muteCall]);

  if (
    session.length > 1 &&
    session[session.length - 1].statusAppel === "ringing" &&
    session[session.length - 1].direction === "incoming"
  ) {
    oopen = true;
  } else {
    oopen = false;
  }
  function DTMF(digit) {
    setNumberDtmf((c) => c.concat(digit));
    sendDTMF(callActive, digit);
  }
  function closeModal() {
    setIsOpen(false);
  }
  function closeModalTransfert() {
    setIsOpenTransfert(false);
  }
  function closeModalSendCall() {
    setIsOpenSendCall(false);
  }
  function closeModalNewcall() {}

  function openModalTransfert() {
    setIsOpenTransfert(true);
  }

  function clickWindow() {
    heightWindow === "none"
      ? (iconWindow = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 m-auto text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {" "}
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
            ></path>{" "}
          </svg>
        ))
      : (iconWindow = (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 m-auto text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            {" "}
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 11l7-7 7 7M5 19l7-7 7 7"
            />{" "}
          </svg>
        ));

    heightWindow === "none"
      ? setHeightWindow("block")
      : setHeightWindow("none");
  }

  function deleteSession(session) {
    return session.conf !== "inviter";
  }

  async function transfertAcc(number) {
    callTransfert(number);

    transfertSession = activecall;
  }

  function endTransferAcc() {
    hungUp(activeTransfert);
    setIsOpenTransfert(false);
    setIsConfirmOpened(false);
    transfertSession = {};
  }
  function sendCallTransfertAcc(num1, session) {
    setIsOpenTransfert(false);
    transfertCallAcc(num1, session);
  }
  const multipleSession = useMemo(() => {
    let multipleSession = [];

    if (session.length > 1 || session[0].conf !== "null")
      multipleSession = session.filter(deleteSession).map((newSess) =>
        newSess === callActive ? (
          newSess.conf === "null" ? (
            newSess.statusAppel !== "ringing" ? (
              <button
                className="bg-white font-bold "
                onClick={() => changeSession(newSess)}
              >
                Appel en cours {newSess.remoteIdentity.uri?.user}{" "}
              </button>
            ) : null
          ) : (
            <button
              className="bg-white font-bold "
              onClick={() => changeSession(newSess)}
            >
              Conférence audio {newSess.remoteIdentity.uri?.user}--
              {newSess.conf.remoteIdentity.uri?.user}
            </button>
          )
        ) : newSess.statusAppel === "ringing" ? (
          <div
            className="bg-green-100 font-bold flex justify-around"
            // onClick={() => changeSession(newSess)}
          >
            <div>{newSess.remoteIdentity.uri?.user}</div>
            <div className="flex">
              {newSess.direction === "incoming" ? (
                <div
                  className="bg-green-600"
                  onClick={() => upBtn(newSess)}
                  style={{
                    height: "30px",
                    width: "30px",
                    borderRadius: "100%",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    style={{ margin: "auto", height: "100%" }}
                  >
                    {" "}
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                  </svg>
                </div>
              ) : null}
              <div
                onClick={() => hungUp(newSess)}
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "100%",
                  backgroundColor: "red",
                  cursor: "pointer",
                  color: "white",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  style={{
                    margin: "auto",
                    transform: "rotate( 136deg )",
                    height: "100%",
                  }}
                >
                  {" "}
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                </svg>
              </div>
            </div>
          </div>
        ) : (
          <button
            className="bg-gray-300 bg-opacity-90 text-sm text-gray-400"
            onClick={() => changeSession(newSess)}
          >
            Appel en pause {newSess.remoteIdentity.uri?.user}
          </button>
        )
      );
    return multipleSession;
  }, [callActive, changeSession, hungUp, session, upBtn]);
  if (
    callActive?.statusAppel === "accepted" ||
    callActive?.statusAppel === "holding" ||
    callActive?.statusAppel === "answered"
  ) {
    ableButton = false;
    opacityButton = "1";
  } else {
    ableButton = true;
    opacityButton = "0.3";
  }

  if (
    callActive?.direction === "incoming" &&
    callActive?.statusAppel === "ringing"
  ) {
    return (
      <div
        className="callPage"
        style={{
          backgroundColor:
            window.switchAPI === "govoice" ? "#182436" : "rgb(8 116 85)",
        }}
        key={1}
      >
        <div id="callButtons" className="callButtons">
          <div className="callLine">
            <div className="userImageIncoming call-animation ">
              {imageCall ? (
                <img
                  className="h-full w-full rounded-full"
                  alt="avatar"
                  src={imageCall}
                />
              ) : (
                <span className="inline-block h-full w-full rounded-full overflow-hidden bg-gray-100 dark:bg-gray-700">
                  <svg
                    className="h-full w-full text-gray-300 dark:text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                  </svg>
                </span>
              )}
            </div>
            <div className="callNumber">{accountCall.name}</div>
            <div className="callNumber">{accountCall.number}</div>
          </div>

          <div className="controlBtn">
            <button
              onClick={() => upBtn(callActive)}
              id="upBtn"
              className="upBtn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
                style={{ margin: "auto" }}
              >
                {" "}
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
              </svg>
            </button>
            {callActive?.type === "video" ? (
              <button
                onClick={() => upBtnVideo(callActive)}
                id="upBtnVideo"
                className="upBtnVideo"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  style={{ margin: "auto" }}
                >
                  {" "}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />{" "}
                </svg>
              </button>
            ) : null}
            <button
              onClick={() => hungUp(callActive)}
              id="hungup"
              className="hungup"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
                style={{ margin: "auto", transform: "rotate( 136deg )" }}
              >
                {" "}
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
              </svg>
            </button>
          </div>
        </div>
        <div className="allSessions flex justify-center flex-col ">
          {multipleSession}
        </div>
      </div>
    );
  } else {
    if (callActive?.conf === "null" && callActive?.type !== "video") {
      return (
        <div
          className="callPage"
          style={{
            backgroundColor:
              window.switchAPI === "govoice" ? "#182436" : "rgb(8 116 85)",
          }}
          key={2}
        >
          <div id="callButtons" className="callButtons">
            <div className="callLine">
              <div className="userImage">
                {imageCall ? (
                  <img
                    className="h-full w-full rounded-full"
                    alt="avatar"
                    src={imageCall}
                  />
                ) : (
                  <span className="inline-block h-full w-full rounded-full overflow-hidden bg-gray-100 dark:bg-gray-700">
                    <svg
                      className="h-full w-full text-gray-300 dark:text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                    </svg>
                  </span>
                )}
              </div>
              <div className="callNumber">{accountCall.name}</div>
              <div className="callNumber">{accountCall.number}</div>
              <div id="watch" className="text-white">
                Appel...
              </div>
            </div>
            {showResults ? (
              <div
                className="callLine w-full"
                style={{
                  opacity: opacityButton,
                  width: navbar ? "85%" : "40%",
                }}
              >
                <div className="callLine flex justify-center">
                  <div className="flex flex-col w-1/3 mx-2 mb-3">
                    <button
                      style={{ backgroundColor: holdCallColor.colorHold }}
                      onClick={() => holdSession(callActive)}
                      type="button"
                      className="btn btn-default digitCall cursor-pointer"
                      disabled={ableButton}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={holdCallColor?.color + " h-6 w-6"}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        style={{ margin: "auto" }}
                      >
                        {" "}
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          width="1"
                          d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />{" "}
                      </svg>
                    </button>
                    <span className="text-xs text-center text-gray-100">
                      pause
                    </span>
                  </div>
                  {!navbar ? (
                    <div className="flex flex-col w-1/3 mx-2 mb-3">
                      <button
                        // onClick={openModalSendCall}
                        onClick={openBackHome}
                        type="button"
                        className="btn btn-default digitCall cursor-pointer"
                        disabled={ableButton}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                          style={{ margin: "auto" }}
                        >
                          {" "}
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 4v16m8-8H4"
                          />{" "}
                        </svg>
                      </button>
                      <span className="text-xs text-center text-gray-100">
                        appel
                      </span>
                    </div>
                  ) : null}
                  <div className="flex flex-col w-1/3 mx-2 mb-">
                    <button
                      type="button"
                      className="btn btn-default digitCall cursor-pointer"
                      style={{ backgroundColor: muteCallColor?.colorMute }}
                      onClick={() => muteSession(callActive)}
                      disabled={ableButton}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={muteCallColor?.colorIconMute + " h-6 w-6"}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        style={{ margin: "auto" }}
                      >
                        {" "}
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          width="1"
                          d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                        />{" "}
                      </svg>
                    </button>
                    <span className="text-xs text-center text-gray-100">
                      silence
                    </span>
                  </div>
                </div>
                <div className="callLine flex justify-center">
                  <div className="flex flex-col w-1/3 mx-2 ">
                    <button
                      onClick={openModalTransfert}
                      type="button"
                      className="btn btn-default digitCall cursor-pointer"
                      disabled={ableButton}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        style={{ margin: "auto" }}
                      >
                        {" "}
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                        />{" "}
                      </svg>
                    </button>
                    <span className="text-xs text-center text-gray-100">
                      transfet
                    </span>
                  </div>
                  <div className="flex flex-col w-1/3 mx-2 ">
                    <button
                      onClick={() => setShowResults(false)}
                      type="button"
                      className="btn btn-default digitCall cursor-pointer"
                      disabled={ableButton}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        style={{ margin: "auto" }}
                      >
                        {" "}
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                        />{" "}
                      </svg>
                    </button>
                    <span className="text-xs text-center text-gray-100">
                      dtmf
                    </span>
                  </div>
                  {!navbar ? (
                    <div className="flex flex-col w-1/3 mx-2 ">
                      <button
                        // onClick={openModal}
                        onClick={openBackHomeConference}
                        type="button"
                        className="btn btn-default digitCall cursor-pointer"
                        disabled={ableButton}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                          style={{ margin: "auto" }}
                        >
                          {" "}
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                          />{" "}
                        </svg>
                      </button>
                      <span className="text-xs text-center text-gray-100">
                        conférence
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : (
              <div className="callLine ">
                <input
                  type="text"
                  name="number"
                  id="numDisplayDtmf"
                  value={numberDtmf}
                  onChange={(e) => setNumberDtmf(e.target.value)}
                  style={{ width: "100%" }}
                />
                <div className="dialLine">
                  <button
                    onClick={() => DTMF(1)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    1
                  </button>
                  <button
                    onClick={() => DTMF(2)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    2
                  </button>
                  <button
                    onClick={() => DTMF(3)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    3
                  </button>
                </div>
                <div className="dialLine">
                  <button
                    onClick={() => DTMF(4)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    4
                  </button>
                  <button
                    onClick={() => DTMF(5)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    5
                  </button>
                  <button
                    onClick={() => DTMF(6)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    6
                  </button>
                </div>
                <div className="dialLine">
                  <button
                    onClick={() => DTMF(7)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    7
                  </button>
                  <button
                    onClick={() => DTMF(8)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    8
                  </button>
                  <button
                    onClick={() => DTMF(9)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    9
                  </button>
                </div>
                <div className="dialLine">
                  <button
                    onClick={() => DTMF("*")}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    *
                  </button>
                  <button
                    onClick={() => DTMF(0)}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    0
                  </button>
                  <button
                    onClick={() => DTMF("#")}
                    type="button"
                    className="btn btn-default digitDTMF cursor-pointer h-10 w-10"
                    style={{ color: "white" }}
                  >
                    #
                  </button>
                </div>
                <div className="dialLine">
                  <button
                    onClick={() => setShowResults(true)}
                    className="text-white w-full"
                  >
                    Masquer
                  </button>
                </div>
              </div>
            )}

            <div className="callLine">
              <div className="flex">
                <button
                  onClick={() => hungUp(callActive)}
                  id="hungup"
                  className="hungup"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    style={{ margin: "auto", transform: "rotate( 136deg )" }}
                  >
                    {" "}
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                  </svg>
                </button>
              </div>
            </div>
            <div className="allSessions flex justify-center flex-col ">
              {multipleSession}
            </div>
          </div>

          {!navbar && backHomeVariable !== "" ? (
            <Home
              navbar={navbar}
              closeBackHome={closeBackHome}
              newcallClick={newcallClick}
              ConferenceCall={ConferenceCall}
              backHomeVariable={backHomeVariable}
            />
          ) : (
            (backHomeVariable = "")
          )}

          {/* send call *****************************************************************/}
          <Transition appear show={isOpenSendCall} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto newCall"
              style={{ backgroundColor: "#000000b3" }}
              onClose={closeModalSendCall}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0" />
                </Transition.Child>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="inline-block h-screen align-middle"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl bg-gray-200">
                    <Dialog.Title
                      as="div"
                      className="text-lg font-medium leading-6 text-gray-900 text-center"
                    >
                      <div className="">
                        <h4>Nouvel appel</h4>
                        <input
                          type="text"
                          className="outline-0 text-gray-900 rounded-2xl text-center"
                          value={numberSendCall}
                          onChange={(e) => setNumberSendCall(e.target.value)}
                        />{" "}
                      </div>
                    </Dialog.Title>

                    <div className="flex justify-evenly">
                      <div className="mt-4">
                        <button
                          type="button"
                          className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          onClick={() => newcallClick(numberSendCall)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            style={{ margin: "auto" }}
                          >
                            {" "}
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>
          {/* end send call *****************************************************************/}

          {/* tranfert *****************************************************************/}
          <Transition appear show={isOpenTransfert} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              style={{ backgroundColor: "#000000b3" }}
              onClose={closeModalTransfert}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0" />
                </Transition.Child>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="inline-block h-screen align-middle"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl bg-gray-200">
                    <Dialog.Title
                      as="div"
                      className="text-lg font-medium leading-6 text-gray-900 text-center"
                    >
                      <h4>{t("transfert.title")} </h4>
                    </Dialog.Title>
                    {isConfirmOpened ? (
                      <div className="flex items-center w-full  flex-1 space-x-2 justify-evenly">
                        <button
                          type="button"
                          className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white  border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          style={{
                            backgroundColor: "red",
                          }}
                          onClick={endTransferAcc}
                        >
                          {t("transfert.cancel")}
                        </button>
                        <button
                          type="button"
                          className=" px-4 py-2 text-sm font-medium text-white  border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 flex justify-center "
                          style={{
                            backgroundColor:
                              activeTransfert !== undefined &&
                              activeTransfert?.statusAppel === "ringing"
                                ? "#d5d5d59c"
                                : "var(--color-primary)",
                          }}
                          disabled={
                            activeTransfert !== undefined &&
                            activeTransfert?.statusAppel === "ringing"
                              ? true
                              : false
                          }
                          onClick={() =>
                            sendCallTransfertAcc(
                              activeTransfert,
                              transfertSession
                            )
                          }
                        >
                          {t("transfert.confirm")}
                        </button>
                      </div>
                    ) : (
                      <div className="flex items-center justify-center flex-col space-y-3">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();

                            const value = e.target.transfert_av.value;
                            if (value && !isNaN(value)) transfertCall(value);
                          }}
                          className="flex justify-evenly    items-center  w-full space-x-2"
                        >
                          <label className="text-gray-500 flex-1 text-sm ">
                            {t("transfert.aveugle")}:
                          </label>
                          <input
                            name="transfert_av"
                            placeholder={t("transfert.placeholder")}
                            type="text"
                            className="outline-0   px-4 py-2 text-gray-900 rounded-2xl text-center"
                          />
                          <button
                            type="submit"
                            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              style={{ margin: "auto" }}
                            >
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                            </svg>
                          </button>
                        </form>
                        <br />
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();

                            const value = e.target.transfert_ac.value;
                            if (value && !isNaN(value)) transfertAcc(value);
                          }}
                          className="flex justify-evenly  items-center w-full space-x-2"
                        >
                          <label className="text-gray-500 flex-1 text-sm ">
                            {t("transfert.accompagne")}:
                          </label>
                          <input
                            name="transfert_ac"
                            placeholder={t("transfert.placeholder")}
                            type="text"
                            className="outline-0  px-4 py-2 text-gray-900 rounded-2xl text-center"
                          />{" "}
                          <button
                            type="submit"
                            className="inline-flex justify-center text-sm px-4 py-2 font-medium text-white bg-green-600 border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              style={{ margin: "auto" }}
                            >
                              {" "}
                              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                            </svg>
                          </button>
                        </form>
                      </div>
                    )}
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>
          {/* end tranfert *****************************************************************/}

          {/* conference *****************************************************************/}
          <Transition appear show={isOpen} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              style={{ backgroundColor: "#000000b3" }}
              onClose={closeModal}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0" />
                </Transition.Child>

                <span
                  className="inline-block h-screen align-middle"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl bg-gray-200">
                    <Dialog.Title
                      as="div"
                      className="text-lg font-medium leading-6 text-gray-900 text-center"
                    >
                      <div className="">
                        <h4>Conférence</h4>
                        <input
                          type="text"
                          className="outline-0 text-gray-900 rounded-2xl text-center"
                          value={number}
                          onChange={(e) => setNumber(e.target.value)}
                        />{" "}
                      </div>
                    </Dialog.Title>

                    <div className="flex justify-evenly">
                      <div className="mt-4">
                        <button
                          type="button"
                          className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          onClick={() => ConferenceCall(number)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            style={{ margin: "auto" }}
                          >
                            {" "}
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>
          {/* end conference *****************************************************************/}
        </div>
      );
    } else if (callActive?.conf === "null" && callActive?.type === "video") {
      return (
        <div>
          <div className="callButtonsVideo">
            <button className="w-full" onClick={clickWindow}>
              {iconWindow}
            </button>
            <div className="callLine" style={{ display: heightWindow }}>
              <div className="callNumber">{accountCall.name}</div>
              <div className="callNumber">{accountCall.number}</div>

              <div id="watch" className="text-white">
                Appel...
              </div>
            </div>
            <div className="callLine" style={{ display: heightWindow }}>
              <div className="callLine flex justify-around">
                <button
                  style={{ backgroundColor: holdCallColor.colorHold }}
                  onClick={() => holdSession(callActive)}
                  type="button"
                  className="btn btn-default digitCallVideo cursor-pointer h-12 w-12"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={holdCallColor.color}
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ margin: "auto" }}
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      width="1"
                      d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />{" "}
                  </svg>
                </button>

                <button
                  style={{ backgroundColor: muteCallColor.colorMute }}
                  onClick={() => muteSession(callActive)}
                  type="button"
                  className="btn btn-default digitCallVideo cursor-pointer h-12 w-12"
                >
                  <svg
                    className={muteCallColor.colorIconMute}
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    style={{ margin: "auto" }}
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      width="1"
                      d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
                    />{" "}
                  </svg>
                </button>
                <button
                  onClick={() => hungUp(callActive)}
                  id="hungup"
                  className="hungupVideo h-12 w-12"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    style={{ margin: "auto", transform: "rotate( 136deg )" }}
                  >
                    {" "}
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                  </svg>
                </button>
              </div>
            </div>

            <div className="allSessions flex justify-center flex-col ">
              {multipleSession}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="callPage"
          style={{
            backgroundColor:
              window.switchAPI === "govoice" ? "#182436" : "rgb(8 116 85)",
          }}
          key={3}
        >
          {/* <button onClick={callClick}>ree</button>

<button onClick={() => holdSession(activecall)}>hold</button> */}

          <div id="callButtons" className="callButtons">
            <div>
              <div className="flex">
                <div className="callLine relative">
                  <div className="userImage" style={{ margin: "0" }}>
                    {imageCall ? (
                      <img
                        className="h-full w-full rounded-full"
                        alt="avatar"
                        src={imageCall}
                      />
                    ) : (
                      <span className="inline-block h-full w-full rounded-full overflow-hidden bg-gray-100 dark:bg-gray-700">
                        <svg
                          className="h-full w-full text-gray-300 dark:text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                        </svg>
                      </span>
                    )}
                  </div>
                  <div className="callNumber">{accountCall.name}</div>
                  <div className="callNumber">{accountCall.number}</div>

                  <button
                    style={{ backgroundColor: holdCallColor.colorHold }}
                    className="holdConf"
                    onClick={() => holdSession(callActive)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={holdCallColor.color}
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      style={{ margin: "auto" }}
                    >
                      {" "}
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        width="1"
                        d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />{" "}
                    </svg>
                  </button>
                  <button
                    className="hungupConf text-white"
                    onClick={() => hungUp(callActive)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      style={{ margin: "auto", transform: "rotate( 136deg )" }}
                    >
                      {" "}
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                    </svg>
                  </button>
                </div>

                <div className="callLine relative">
                  <div className="userImage"></div>
                  <div className="callNumber">
                    {callActive?.conf.remoteIdentity.uri?.user}
                  </div>
                  <button
                    style={{ backgroundColor: holdCallColor.colorHoldMember }}
                    className="holdConf"
                    onClick={() => holdSession(callActive?.conf)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={holdCallColor.colorMember}
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      style={{ margin: "auto" }}
                    >
                      {" "}
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        width="1"
                        d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />{" "}
                    </svg>
                  </button>
                  <button
                    className="hungupConf text-white"
                    onClick={() => hungUp(callActive?.conf)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      style={{ margin: "auto", transform: "rotate( 136deg )" }}
                    >
                      {" "}
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                    </svg>
                  </button>
                </div>
              </div>
              <div id="watch" className="text-white">
                Appel...
              </div>
            </div>

            <div className="allSessions flex justify-center flex-col ">
              {multipleSession}
            </div>
          </div>

          <Transition appear show={oopen} as={Fragment}>
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              style={{ backgroundColor: "#000000b3" }}
              onClose={closeModalNewcall}
            >
              <div className="min-h-screen px-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Dialog.Overlay className="fixed inset-0" />
                </Transition.Child>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="inline-block h-screen align-middle"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl bg-gray-400">
                    <Dialog.Title
                      as="div"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="userImage m-auto call-animation"></div>
                    </Dialog.Title>

                    <div className="flex justify-evenly">
                      <div className="mt-4">
                        <button
                          type="button"
                          className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          onClick={() => upBtn(session[session.length - 1])}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            style={{ margin: "auto" }}
                          >
                            {" "}
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                          </svg>
                        </button>
                      </div>

                      <div className="mt-4">
                        <button
                          type="button"
                          className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-full hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                          onClick={() => hungUp(session[session.length - 1])}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            style={{
                              margin: "auto",
                              transform: "rotate( 136deg )",
                            }}
                          >
                            {" "}
                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </Dialog>
          </Transition>
          {/* tranfert *****************************************************************/}
        </div>
      );
    }
  }
}

export default CallPage;
